export enum InspectionOwner {
    UI = 'UI',
    SW = 'SW'
}